module.exports = __webpack_public_path__ + "img/Penny-Hat-04.608ee84b.jpg";